<div class="container-fluid mb-5">
  <div class="row">
    <div class="col-12 mt-2">
      <form autocomplete="off" [formGroup]="form">
          <div class="card mb-3 bg-2">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <carteira-autocomplete [schema]="carteiraSchema"></carteira-autocomplete>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <lib-autocomplete [schema]="regraSchema"></lib-autocomplete>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <lib-datepicker-day [schema]="dataInicioSchema"></lib-datepicker-day>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <lib-datepicker-day
                    [schema]="dataFimSchema"
                  ></lib-datepicker-day>
                </div>
                <div class="col-xl-2"></div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Status regra</mat-label>
                    <mat-select formControlName="status">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let s of status" [value]="s.id">
                        {{ s.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Execução</mat-label>
                    <mat-select formControlName="tiposExecucao">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let tE of tiposExecucao" [value]="tE.id">
                        {{ tE.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                    <mat-slide-toggle class="mt-4" [color]="'primary'" [formControlName]="'ativaUltimaDataProcessamento'">Última - Data hora execução</mat-slide-toggle>
                  </div>
              </div>
            </div>
            <div class="card-footer clearfix">
                <div class="d-flex flex-row justify-content-end">
                  <div class="pr-3">
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="page$.next(1)"
                      [disabled]="form.invalid || (loading$ | async)"
                      label="Pesquisar"
                      type="submit"
                      title="Pesquisar"
                      aria-label="left">
                      <loading-icon
                        class="align-content-center"
                        [btnLabel]="'Pesquisar'"
                        [loading]="loading$ | async"
                      ></loading-icon>
                    </button>
                  </div>
                  <div>
                    <button mat-raised-button
                      [matMenuTriggerFor]="menuExportarResultado"
                      [disabled]="(loadingExport$ | async)">
                      <loading-icon
                          [btnLabel]="'Exportar'"
                          [loading]="loadingExport$ | async"
                      ></loading-icon> <span class="caret"></span>
                    </button>
                    <mat-menu #menuExportarResultado="matMenu">
                      <button mat-menu-item (click)="exportarPdf()">
                        <span>PDF</span>
                      </button>
                      <button mat-menu-item (click)="exportarXls()">
                        <span>Excel</span>
                      </button>
                    </mat-menu>
                  </div>
                  <div class="col-sm-0">
                    <button mat-icon-button type="button" class="tooltip-400" [tooltip]="popTemplate" [placement]="'left'">
                      <i class="fa fa-info-circle"></i>
                    </button>
                    <ng-template #popTemplate
                    ><span style="font-size: 0.9em !important">
                      Regra composta: a versão em Excel não apresenta a abertura das regras simples que a compõem.
                      Essa abertura está disponível na versão em tela e pdf.
                    </span>
                    </ng-template>
                  </div>
              </div>
            </div>
          </div>
      </form>
      <app-total-table
        [showRegistersPerPage]="true"
        (onChange)="updatePageSize($event)"
        [totalRegistros]="this.totalRegistros"></app-total-table>
      <table class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
        <thead>
          <tr>
            <th>Carteira</th>
            <th>Data</th>
            <th>Data hora execução</th>
            <th>Execução</th>
            <th>Regra</th>
            <th>Status regra</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let r of resultadoRegras">
            <tr class="element-row">
              <td>{{ r.carteira.nome }}</td>
              <td>{{ r.dataEnquadramento | date: 'dd/MM/yyyy' }}</td>
              <td>{{ r.timeStamp | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ getTipoExecucao(r.tipoExecucao) }}</td>
              <td class="regra" (click)="rowClicked(r)" >
                <i *ngIf="r == expandedElement && r.subregras && r.subregras.length > 0" class="fas fa-minus-square subregra-button" aria-hidden="true"></i>
                <i *ngIf="r != expandedElement && r.subregras && r.subregras.length > 0" class="fas fa-plus-square subregra-button" aria-hidden="true"></i>
                {{ r.regra.nome }}
              </td>
              <td>{{ r.status }}</td>
              <td class="pt-1 pb-1">
                <div class="d-flex flex-row justify-content-center">
                  <div class="pr-2">
                    <button mat-icon-button type="button" (click)="detail.openInfoDialog(r)" title="Mensagem">
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div>
                    <button mat-icon-button type="button" (click)="confirmDialog(r)" title="Memória cálculo" data-toggle="modal"
                      data-target="#confirm-dialog-modal">
                      <i class="fas fa-list" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div>
                    <button
                      mat-icon-button
                      type="button"
                      (click)="exportarComposicaoCarteira(r.id)"
                      title="Composição da carteira">
                      <i class="fas fa-download" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <ng-container *ngIf="r == expandedElement">
              <tr *ngFor="let s of r.subregras"  class="opacity-4">
                <td>{{ s.carteira.nome }}</td>
                <td>{{ s.dataEnquadramento | date: 'dd/MM/yyyy' }}</td>
                <td>{{ s.timeStamp | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>{{ getTipoExecucao(r.tipoExecucao) }}</td>
                <td class="subregra">{{ s.regra.nome }}</td>
                <td>{{ s.status }}</td>
                <td class="pt-1 pb-1">
                  <div class="d-flex flex-row justify-content-center">
                    <div class="pr-2">
                      <button mat-icon-button type="button" (click)="detail.openInfoDialog(s)" title="Mensagem">
                        <i class="fas fa-search" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div>
                      <button
                        mat-icon-button
                        type="button"
                        (click)="confirmDialog(s)"
                        title="Memória cálculo"
                        data-toggle="modal"
                        data-target="#confirm-dialog-modal">
                        <i class="fas fa-list" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div>
                      <button
                        mat-icon-button
                        type="button"
                        (click)="exportarComposicaoCarteira(s.id)"
                        title="Composição da carteira">
                        <i class="fas fa-download" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <maps-pagination
      [pageNumber]="page$"
      [items]="paginationTotalPage"
      *ngIf="paginationTotalPage && paginationTotalPage > 0"
      (pageSend)="receiverPage($event)"
    ></maps-pagination>
  </div>
  <app-resultado-regra-detalhe
    class="detail"
    #detail
  ></app-resultado-regra-detalhe>
</div>


